import { render, staticRenderFns } from "./kpInfo.vue?vue&type=template&id=81d7ad8c&"
import script from "./kpInfo.vue?vue&type=script&lang=js&"
export * from "./kpInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports